import Swal from 'sweetalert2';
import emailjs from 'emailjs-com';
import './styles.css';

const Forms = () => {
  const SERVICE_ID = 'service_lws2w3p';
  const TEMPLATE_ID = 'template_aqwaca3';
  const PUBLIC_KEY = 'S0virmLuIo_XsLF4q';

  const handleOnSubmit = (e: any) => {
    e.preventDefault();
    emailjs.sendForm(SERVICE_ID, TEMPLATE_ID, e.target, PUBLIC_KEY)
      .then(() => {
        Swal.fire({
          icon: 'success',
          title: 'Message sent successfully',
          text: "Thank you for contacting Rue's Events Designs. We'll be in touch soon.",
        });
      }, (error) => {
        Swal.fire({
          icon: 'error',
          title: 'Something went wrong',
          text: error.text,
        });
      });
    e.target.reset();
  };

  return (
    <div className="Contactform">
      <div id="intouch">
        <p className="section-kicker">Send us a message</p>
        <h2>Start planning your event.</h2>
        <p>Complete the form below and tell us how we can help.</p>
      </div>

      <form className="rue-contact-form" onSubmit={handleOnSubmit}>
        <label htmlFor="user_name">Name</label>
        <input id="user_name" name="user_name" type="text" placeholder="Your name" required />

        <label htmlFor="user_email">Email</label>
        <input id="user_email" name="user_email" type="email" placeholder="Your email address" required />

        <label htmlFor="user_message">Message</label>
        <textarea
          id="user_message"
          name="user_message"
          placeholder="Tell us about your event, preferred date and what you have in mind..."
          required
        />

        <button id="button" type="submit">Send Enquiry</button>
      </form>
    </div>
  );
};

export default Forms;
